import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { QueryStringParameterKey } from "src/app/shared/routes/shared/shared-route.constant";
import { AppState } from "src/app/shared/store/app.state";
import * as TermLifeInsuranceQuoteActions from "src/app/shared/store/quote/term-life-insurance/quote.actions";

export const getTermLifeInsuranceQuoteWithProductConfigurationResolver: ResolveFn<
  null
> = (
  activatedRouteSnapshot: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
) => {
  const store = inject(Store<AppState>);
  const quoteIdUrl = activatedRouteSnapshot.queryParamMap.get(
    QueryStringParameterKey.QUOTE_ID,
  );

  // Fire & forget (non-blocking resolver)
  if (quoteIdUrl) {
    store.dispatch(
      TermLifeInsuranceQuoteActions.getTermLifeInsuranceQuote({
        quoteId: quoteIdUrl,
      }),
    );
  } else {
    // We don't have a quoteId yet and thus only request the product configuration
    // They are needed to render some of the pages (e.g bmi limitation, allowedInsuranceDates, ..)
    store.dispatch(TermLifeInsuranceQuoteActions.getProductConfiguration());
  }

  // It seems that the resolver is forced to return a value as just completing
  // the Observable via EMPTY did not work.
  return of(null);
};
